import { makeRecord, objectKeys } from '@arc/shared/util-js';
import { minPatchObject, minPatchPrimitive } from '@arc/shared/util-superstruct';
import { EditUserDto } from './edit-user.dto';
export const minPatchEditUserDto = minPatchObject({
  ...makeRecord(objectKeys(EditUserDto.schema), () => minPatchPrimitive)
});